<template>
    <v-container>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card class="mt-4">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard"> Detalles Proceso</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-form lazy-validation ref="form">
                    <v-row justify="center" v-if="loaded">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-else>
                        <v-col cols="12" md="9">
                            <v-row>
                                <v-col cols="12" md="3">
                                    <span style="font-weight: bold;">Id Proceso:</span>
                                    <v-text-field outlined width="20px" dense v-model="alta.ntclave" maxlength="100"
                                        :rules="altarules" readonly filled></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <span style="font-weight: bold;">Proceso:</span>
                                    <v-text-field outlined width="20px" dense v-model="alta.proceso" maxlength="100"
                                        :rules="altarules" :disabled="disEditar" :filled="disEditar"
                                        @blur="alta.proceso = alta.proceso != null ? alta.proceso.trim() : null"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <span style="font-weight: bold;">Sitio:</span>
                                    <multiselect v-model="alta.sitio"
                                        deselect-label="No se puede remover el valor seleccionado"
                                        selected-label="Seleccionado" select-label="Seleccione un sitio"
                                        track-by="ntsitio" label="ntsitio" placeholder="Seleccione un sitio"
                                        :options="Sitio.CatalogoSitios" :allow-empty="false" :disabled="disEditar">
                                    </multiselect>
                                    <span v-if="valSitio" style="color: #FF5C93; font-size: 12px">Campo
                                        requerido</span>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <span style="font-weight: bold;">Módulo:</span>
                                    <v-text-field outlined width="20px" dense maxlength="100" v-model="alta.modulo"
                                        :rules="altarules" :disabled="disEditar" :filled="disEditar"
                                        @blur="alta.modulo = alta.modulo != null ? alta.modulo.trim() : null"></v-text-field>
                                </v-col>
                            </v-row>
                            <template>
                                <v-row>
                                    <v-stepper v-model="currentStep" width="100%">
                                        <v-stepper-header>
                                            <v-stepper-step complete edit-icon="mdi-bell" step="1" editable
                                                :rules="[() => !hasErrors || 'Hay errores en el formulario']"
                                                :style="{ background: currentStep == 1 ? '#c9d6ec' : 'none' }">
                                                Texto Notificación
                                            </v-stepper-step>
                                            <v-divider></v-divider>
                                            <v-stepper-step complete step="2" edit-icon="mdi-email" editable
                                                :rules="[() => !hasErrorsC || 'Hay errores en el formulario']"
                                                :style="{ background: currentStep == 2 ? '#c9d6ec' : 'none' }">
                                                Texto Correo
                                            </v-stepper-step>
                                            <v-divider></v-divider>
                                            <v-stepper-step complete step="3" edit-icon="mdi-message-text" editable
                                                :rules="[() => !hasErrorsS || 'Hay errores en el formulario']"
                                                :style="{ background: currentStep == 3 ? '#c9d6ec' : 'none' }">
                                                Texto SMS
                                            </v-stepper-step>
                                            <v-divider></v-divider>
                                            <v-stepper-step complete step="4" edit-icon="mdi-whatsapp" editable
                                                :rules="[() => !hasErrorsW || 'Hay errores en el formulario']"
                                                :style="{ background: currentStep == 4 ? '#c9d6ec' : 'none' }">
                                                Texto WhatsApp
                                            </v-stepper-step>
                                            <v-divider></v-divider>
                                            <v-stepper-step complete step="5" edit-icon="mdi-cellphone-message" editable
                                                :rules="[() => !hasErrorsP || 'Hay errores en el formulario']"
                                                :style="{ background: currentStep == 5 ? '#c9d6ec' : 'none' }">
                                                Push Notificación
                                            </v-stepper-step>
                                        </v-stepper-header>
                                        <v-stepper-items>
                                            <v-stepper-content step="1">
                                                <v-card>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col style="display: grid; place-items: center;">
                                                                <span
                                                                    style="font-size: large;  font-weight: bold;">Agregar
                                                                    Notificación</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <span class="type-label-style">Texto
                                                                    Notificación:</span>
                                                                <v-textarea style="padding-left: 0px !important;"
                                                                    id="textareaobs" outlined maxlength="10000"
                                                                    counter="10000" v-model="altanoti.textNoti"
                                                                    :rules="rulesTexto" :disabled="disEditar"
                                                                    :filled="disEditar"
                                                                    @blur="altapush.textNoti = altapush.textNoti != null ? altapush.textNoti.trim() : null"></v-textarea>
                                                                <br>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="10">
                                                                <span class="type-label-style">Requiere agregar algún
                                                                    destinatario para la notificación:</span>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <v-switch :disabled="btnswitch"
                                                                    v-model="altanoti.switch"></v-switch>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar usuarios:</span>
                                                                <multiselect v-model="altanoti.usuario"
                                                                    deselect-label="Seleccione para remover el valor seleccionado"
                                                                    selected-label="Seleccionado"
                                                                    select-label="Seleccione un usuario"
                                                                    track-by="Login" label="descrip"
                                                                    placeholder="Seleccione un usuario"
                                                                    :options="Usuarios.CatalogoUsuarios"
                                                                    :allow-empty="true" :multiple="true"
                                                                    :disabled="btnusuario" open-direction="top">
                                                                </multiselect>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar perfil para
                                                                    usuarios:</span>
                                                                <multiselect v-model="altanoti.perfil"
                                                                    deselect-label="Seleccione para remover el valor seleccionado"
                                                                    selected-label="Seleccionado"
                                                                    select-label="Seleccione un perfil"
                                                                    track-by="pfclave" label="pfdesc"
                                                                    placeholder="Seleccione un perfil"
                                                                    :options="Perfiles.CatalogoPerfiles"
                                                                    :allow-empty="true" :multiple="true"
                                                                    :disabled="btnperfil" open-direction="top">
                                                                </multiselect>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="valNoti"
                                                            style="display: grid; place-items: center;">
                                                            <span style="color: #FF5C93; font-size: 12px">Alguno de los
                                                                campos
                                                                es requerido</span>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-stepper-content>
                                            <v-stepper-content step="2">
                                                <v-card>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col style="display: grid; place-items: center;">
                                                                <span
                                                                    style="font-size: large;  font-weight: bold;">Agregar
                                                                    Correo</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <span class="type-label-style">Texto Correo:</span>
                                                                <v-textarea style="padding-left: 0px !important;"
                                                                    id="textareaobs" outlined maxlength="10000"
                                                                    counter="10000" v-model="altacorreo.textcorreo"
                                                                    :rules="rulesTexto" :disabled="disEditar"
                                                                    :filled="disEditar"
                                                                    @blur="altacorreo.textcorreo = altacorreo.textcorreo != null ? altacorreo.textcorreo.trim() : null"></v-textarea>
                                                                <br>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="10">
                                                                <span class="type-label-style">Requiere agregar algún
                                                                    destinatario para el correo:</span>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <v-switch :disabled="btnswitch2"
                                                                    v-model="altacorreo.switch"></v-switch>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar correos:</span>
                                                                <v-autocomplete solo chips clearable deletable-chips
                                                                    :items="correos.items" v-model="correos.valor"
                                                                    :search-input.sync="correos.searchIteam"
                                                                    no-data-text="Introduzca un correo válido"
                                                                    @keyup="addMailValider('correo')"
                                                                    @change="resetItemsSelector('correo')"
                                                                    :disabled="discorreos"></v-autocomplete>
                                                                <v-chip class="ma-2" :close="closeChipCorreo"
                                                                    color="#536DFE" dark
                                                                    v-for="(chips, chipIndex) in correos.selectedItems"
                                                                    :key="chipIndex"
                                                                    @click:close="deleteFromList('correo', chips)">
                                                                    {{ chips }}
                                                                </v-chip>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar perfil para
                                                                    correos:</span>
                                                                <multiselect v-model="altacorreo.pcorreo"
                                                                    deselect-label="Seleccione para remover el valor seleccionado"
                                                                    selected-label="Seleccionado"
                                                                    select-label="Seleccione un perfil"
                                                                    track-by="pfclave" label="pfdesc"
                                                                    placeholder="Seleccione un perfil"
                                                                    :options="PerfilCorreo.CatalogoPerfilCorreo"
                                                                    :allow-empty="true" :multiple="true"
                                                                    :disabled="btnpcorreo" open-direction="top">
                                                                </multiselect>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="valcorreo"
                                                            style="display: grid; place-items: center;">
                                                            <span style="color: #FF5C93; font-size: 12px">Alguno de los
                                                                campos es requerido</span>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar correos con
                                                                    copia:</span>
                                                                <v-autocomplete solo chips clearable deletable-chips
                                                                    :items="correosCopia.items"
                                                                    v-model="correosCopia.valor"
                                                                    :search-input.sync="correosCopia.searchIteam"
                                                                    no-data-text="Introduzca un correo válido"
                                                                    @keyup="addMailValider('copia')"
                                                                    @change="resetItemsSelector('copia')"
                                                                    :disabled="discorreos"></v-autocomplete>
                                                                <v-chip class="ma-2" :close="closeChipCorreo"
                                                                    color="#536DFE" dark
                                                                    v-for="(chips, chipIndex) in correosCopia.selectedItems"
                                                                    :key="chipIndex"
                                                                    @click:close="deleteFromList('copia', chips)">
                                                                    {{ chips }}
                                                                </v-chip>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar perfil para
                                                                    correos con copia:</span>
                                                                <multiselect v-model="altacorreo.pcorreocopia"
                                                                    deselect-label="Seleccione para remover el valor seleccionado"
                                                                    selected-label="Seleccionado"
                                                                    select-label="Seleccione un perfil"
                                                                    track-by="pfclave" label="pfdesc"
                                                                    placeholder="Seleccione un perfil"
                                                                    :options="PerfilCorreo.CatalogoPerfilCorreo"
                                                                    :allow-empty="true" :multiple="true"
                                                                    :disabled="btnpcorreo" open-direction="top">
                                                                </multiselect>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar correos con copia
                                                                    oculta:</span>
                                                                <v-autocomplete solo chips clearable deletable-chips
                                                                    :items="correosCO.items" v-model="correosCO.valor"
                                                                    :search-input.sync="correosCO.searchIteam"
                                                                    no-data-text="Introduzca un correo válido"
                                                                    @keyup="addMailValider('co')"
                                                                    @change="resetItemsSelector('co')"
                                                                    :disabled="discorreos"></v-autocomplete>
                                                                <v-chip class="ma-2" :close="closeChipCorreo"
                                                                    color="#536DFE" dark
                                                                    v-for="(chips, chipIndex) in correosCO.selectedItems"
                                                                    :key="chipIndex"
                                                                    @click:close="deleteFromList('co', chips)">
                                                                    {{ chips }}
                                                                </v-chip>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar perfil para
                                                                    correos
                                                                    con copia oculta:</span>
                                                                <multiselect v-model="altacorreo.pcorreocopiaoculta"
                                                                    deselect-label="Seleccione para remover el valor seleccionado"
                                                                    selected-label="Seleccionado"
                                                                    select-label="Seleccione un perfil"
                                                                    track-by="pfclave" label="pfdesc"
                                                                    placeholder="Seleccione un perfil"
                                                                    :options="PerfilCorreo.CatalogoPerfilCorreo"
                                                                    :allow-empty="true" :multiple="true"
                                                                    :disabled="btnpcorreo" open-direction="top">
                                                                </multiselect>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-stepper-content>
                                            <v-stepper-content step="3">
                                                <v-card>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col style="display: grid; place-items: center;">
                                                                <span
                                                                    style="font-size: large;  font-weight: bold;">Agregar
                                                                    SMS</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col>
                                                                <span class="type-label-style">Texto SMS:</span>
                                                                <v-textarea v-model="altasms.textsms"
                                                                    style="padding-left: 0px !important;"
                                                                    id="textareaobs" outlined maxlength="10000"
                                                                    counter="10000" :rules="rulesTexto"
                                                                    :disabled="disEditar" :filled="disEditar"
                                                                    @blur="altasms.textsms = altasms.textsms != null ? altasms.textsms.trim() : null"></v-textarea>
                                                                <br>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col>
                                                                <span class="type-label-style">Requiere agregar algún
                                                                    destinatario para el SMS:</span>
                                                            </v-col>
                                                            <v-col>
                                                                <v-switch :disabled="btnswitch3"
                                                                    v-model="altasms.switch"></v-switch>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar teléfonos:</span>
                                                                <v-autocomplete solo chips clearable deletable-chips
                                                                    :items="telefonos.items" v-model="telefonos.valor"
                                                                    :search-input.sync="telefonos.searchIteam"
                                                                    no-data-text="Introduzca un teléfono válido"
                                                                    @keyup="addTelValider('tel')"
                                                                    @change="resetItemsSelector('tel')"
                                                                    :disabled="distels"
                                                                    @keypress="validarRegex($event, 'N')"
                                                                    maxlength="10"></v-autocomplete>
                                                                <v-chip class="ma-2" :close="closeChipSMS"
                                                                    color="#536DFE" dark
                                                                    v-for="(chips, chipIndex) in telefonos.selectedItems"
                                                                    :key="chipIndex"
                                                                    @click:close="deleteFromList('tel', chips)">
                                                                    {{ chips }}
                                                                </v-chip>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar perfil para
                                                                    teléfonos:</span>
                                                                <multiselect v-model="altasms.perfilTel"
                                                                    deselect-label="Seleccione para remover el valor seleccionado"
                                                                    selected-label="Seleccionado"
                                                                    select-label="Seleccione un perfil"
                                                                    track-by="pfclave" label="pfdesc"
                                                                    placeholder="Seleccione un perfil"
                                                                    :options="PerfilTelefono.CatalogoPerfilTel"
                                                                    :allow-empty="true" :multiple="true"
                                                                    :disabled="btnptel" open-direction="top">
                                                                </multiselect>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="valSMS"
                                                            style="display: grid; place-items: center;">
                                                            <span style="color: #FF5C93; font-size: 12px">Alguno de los
                                                                campos
                                                                es requerido</span>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-stepper-content>
                                            <v-stepper-content step="4">
                                                <v-card>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col style="display: grid; place-items: center;">
                                                                <span
                                                                    style="font-size: large;  font-weight: bold;">Agregar
                                                                    WhatsApp</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col>
                                                                <span class="type-label-style">Nombre del
                                                                    Template:</span>
                                                                <v-text-field outlined width="20px" dense
                                                                    v-model="altaWhatsapp.nameTemplate" maxlength="150"
                                                                    :disabled="disEditar" :filled="disEditar"
                                                                    @blur="altaWhatsapp.nameTemplate = altaWhatsapp.nameTemplate != '' ? altaWhatsapp.nameTemplate.trim() : ''"></v-text-field>
                                                                <span v-if="valtemp"
                                                                    style="color: #FF5C93; font-size: 12px">Campo
                                                                    requerido</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col>
                                                                <span class="type-label-style">Texto WhatsApp:</span>
                                                                <v-textarea style="padding-left: 0px !important;"
                                                                    id="textareaobs" outlined maxlength="10000"
                                                                    counter="10000" v-model="altaWhatsapp.textWhatsapp"
                                                                    :rules="rulesTexto" :disabled="disEditar"
                                                                    :filled="disEditar"
                                                                    @blur="altaWhatsapp.textWhatsapp = altaWhatsapp.textWhatsapp != null ? altaWhatsapp.textWhatsapp.trim() : null"></v-textarea>
                                                                <br>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col>
                                                                <span class="type-label-style">Texto WhatsApp en
                                                                    Inglés:</span>
                                                                <v-textarea style="padding-left: 0px !important;"
                                                                    id="textareaobs" outlined maxlength="10000"
                                                                    counter="10000" v-model="altaWhatsapp.txtWhatsappUS"
                                                                    :rules="rulesTexto" :disabled="disEditar"
                                                                    :filled="disEditar"
                                                                    @blur="altaWhatsapp.txtWhatsappUS = altaWhatsapp.txtWhatsappUS != null ? altaWhatsapp.txtWhatsappUS.trim() : null"></v-textarea>
                                                                <br>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="valtxtW">
                                                            <span style="color: #FF5C93; font-size: 12px">Debe ingresar
                                                                un texto para Whatsapp</span>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="10">
                                                                <span class="type-label-style">Requiere agregar algún
                                                                    destinatario para el WhatsApp:</span>
                                                            </v-col>
                                                            <v-col cols="2">
                                                                <v-switch :disabled="btnswitch4"
                                                                    v-model="altaWhatsapp.switch"></v-switch>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar teléfonos:</span>
                                                                <v-autocomplete solo chips clearable deletable-chips
                                                                    :items="telefonos.items" v-model="telefonos.valor"
                                                                    :search-input.sync="telefonos.searchIteam"
                                                                    no-data-text="Introduzca un teléfono válido"
                                                                    @keyup="addTelValider('tel')"
                                                                    @change="resetItemsSelector('tel')"
                                                                    :disabled="distelsW"
                                                                    @keypress="validarRegex($event, 'N')"
                                                                    maxlength="10"></v-autocomplete>
                                                                <v-chip class="ma-2" :close="closeChip" color="#536DFE"
                                                                    dark
                                                                    v-for="(chips, chipIndex) in telefonos.selectedItems"
                                                                    :key="chipIndex"
                                                                    @click:close="deleteFromList('tel', chips)">
                                                                    {{ chips }}
                                                                </v-chip>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <span class="type-label-style">Agregar perfil para
                                                                    teléfonos:</span>
                                                                <multiselect v-model="altasms.perfilTel"
                                                                    deselect-label="Seleccione para remover el valor seleccionado"
                                                                    selected-label="Seleccionado"
                                                                    select-label="Seleccione un perfil"
                                                                    track-by="pfclave" label="pfdesc"
                                                                    placeholder="Seleccione un perfil"
                                                                    :options="PerfilTelefono.CatalogoPerfilTel"
                                                                    :allow-empty="true" :multiple="true"
                                                                    :disabled="btnptelW" open-direction="top">
                                                                </multiselect>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row v-if="valWhats"
                                                            style="display: grid; place-items: center;">
                                                            <span style="color: #FF5C93; font-size: 12px">Alguno de los
                                                                campos es requerido</span>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-stepper-content>
                                            <v-stepper-content step="5">
                                                <v-card>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col style="display: grid; place-items: center;">
                                                                <span
                                                                    style="font-size: large;  font-weight: bold;">Agregar
                                                                    Notificación Push</span>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <span class="type-label-style">Texto Notificación
                                                                    Push:</span>
                                                                <v-textarea style="padding-left: 0px !important;"
                                                                    id="textareaobs" outlined maxlength="10000"
                                                                    counter="10000" v-model="altapush.textNotiPush"
                                                                    :rules="rulesTexto" :disabled="disEditar"
                                                                    :filled="disEditar"
                                                                    @blur="altapush.textNotiPush = altapush.textNotiPush != null ? altapush.textNotiPush.trim() : null"></v-textarea>
                                                                <br>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-stepper-content>
                                        </v-stepper-items>
                                    </v-stepper>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <span v-if="valSinText" style="color: #FF5C93; font-size: 12px">Hace falta
                                            ingresar texto, al menos en alguna Notificación, Correo, SMS, WhatsApp o
                                            Notificación Push</span>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;" v-if="!loaded">
                <div mt-2>
                    <v-btn class="mr-4" color="#536DFE" style="color:white" @click="Editar()" :disabled="btndis"
                        v-if="showEditar">Editar</v-btn>
                    <v-btn class="mr-4" color="#536DFE" style="color:white" @click="Guardar()" :disabled="btndis"
                        v-else>Guardar</v-btn>
                    <v-btn class="mr-4" color="default" style="color:white" @click="limpiar()" :disabled="btndis"
                        v-if="!showEditar">Limpiar</v-btn>
                    <v-btn class="mr-4" color="secondary" style="color:white" @click="Cancelar()"
                        :disabled="btndis">Cancelar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
    },
    data() {
        return {
            permisoSistemas: false,
            valSitio: false,
            valSinText: false,
            valNoti: false,
            val: 0,
            alta: {
                proceso: null,
                sitio: null,
                modulo: null,
                ntclave: null
            },
            altarules: [
                v => !!v || 'Campo requerido',
            ],
            rulesTexto: [
                (v) => {
                    if (v == null || v.trim().length == 0) {
                        return true;
                    } else {
                        if (v.trim().length < 6) {
                            return "Mínimo 6 caracteres";
                        } else if (v.trim().length > 10000) {
                            return "Máximo 10000 caracteres";
                        } else return true;
                    }
                },
            ],
            altanoti: {
                perfil: [],
                textNoti: '',
                switch: null,
                usuario: []
            },
            altacorreo: {
                textcorreo: '',
                switch: null,
                pcorreo: [],
                pcorreocopia: [],
                pcorreocopiaoculta: []
            },
            altasms: {
                textsms: '',
                switch: null,
                perfilTel: [],
            },
            altaWhatsapp: {
                textWhatsapp: '',
                switch: null,
                perfilTel: [],
                txtWhatsappUS: '',
                nameTemplate: ''
            },
            Sitio: {
                CatalogoSitios: [],
                ntsitio: '',
            },
            btnswitch: true,
            btnswitch2: true,
            btnswitch3: true,
            btnswitch4: true,
            btnusuario: true,
            btnperfil: true,
            Perfiles: {
                CatalogoPerfiles: [],
                pfclave: '',
            },
            Usuarios: {
                CatalogoUsuarios: [],
                Login: '',
            },
            correos: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            correosCopia: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            correosCO: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            telefonos: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            telefonosW: {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            },
            mailSelected: 0,
            discorreos: true,
            PerfilCorreo: {
                CatalogoPerfilCorreo: [],
                perfil: '',
            },
            btnpcorreo: true,
            btnptel: true,
            PerfilTelefono: {
                CatalogoPerfilTel: [],
                perfil: '',
            },
            distels: true,
            btnptelW: true,
            distelsW: true,
            currentStep: 1,
            valn: 0,
            hasErrors: false,
            valcorreo: false,
            valc: 0,
            hasErrorsC: false,
            vals: 0,
            hasErrorsS: false,
            valSMS: false,
            valWhats: false,
            valw: 0,
            hasErrorsW: false,
            valtemp: false,
            btndis: false,
            altapush: {
                textNotiPush: ''
            },
            hasErrorsP: false,
            valp: 0,
            valtxtW: false,
            showEditar: true,
            disEditar: true,
            loaded: true,
            closeChip: false,
            closeChipSMS: false,
            closeChipCorreo: false,
            uslogin: null,

            valNotiDatosExtra: false,
            valCorreoDatosExtra: false,
            valsmsDatosExtra: false,
            valWhatsDatosExtra: false,
        };
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    watch: {
        'altanoti.textNoti'(val) {
            if (val != null) {
                if (val.trim().length > 0) {
                    this.valSinText = false;
                    if (val.trim().length >= 12) {
                        this.btnswitch = false;
                        this.btnusuario = false;
                        this.btnperfil = false;
                        this.altanoti.switch = true;
                    } else {
                        this.btnswitch = true;
                        this.btnusuario = true;
                        this.btnperfil = true;
                        this.altanoti.switch = false;
                    }
                } else {
                    this.btnswitch = true;
                    this.btnusuario = true;
                    this.btnperfil = true;
                    this.altanoti.switch = false;
                }
            }
        },
        'altacorreo.textcorreo'(val) {
            if (val != null) {
                if (val.trim().length > 0) {
                    this.valSinText = false;
                    if (val.trim().length >= 12) {
                        this.btnswitch2 = false;
                        this.discorreos = false;
                        this.btnpcorreo = false;
                        this.altacorreo.switch = true;
                    } else {
                        this.btnswitch2 = true;
                        this.discorreos = true;
                        this.btnpcorreo = true;
                        this.altacorreo.switch = false;
                    }
                } else {
                    this.btnswitch2 = true;
                    this.discorreos = true;
                    this.btnpcorreo = true;
                    this.altacorreo.switch = false;
                }
            }
        },
        'altasms.textsms'(val) {
            if (val != null) {
                if (val.trim().length > 0) {
                    this.valSinText = false;
                    if (val.trim().length >= 12) {
                        this.btnswitch3 = false;
                        this.altasms.switch = true;
                        this.btnptel = false;
                        this.distels = false;
                    } else {
                        this.btnswitch3 = true;
                        this.altasms.switch = false;
                        this.btnptel = true;
                        this.distels = true;
                    }
                }
                else {
                    this.btnswitch3 = true;
                    this.altasms.switch = false;
                    this.btnptel = true;
                    this.distels = true;
                }
            }
        },
        'altapush.textNotiPush'(val) {
            if (val != null) {
                if (val.trim().length > 0) {
                    this.valSinText = false;
                }
            }
        },
        'altaWhatsapp.textWhatsapp'(val) {
            if (val != null) {
                this.handleTextChange(val);
            }
        },
        'altaWhatsapp.txtWhatsappUS'(val) {
            if (val != null) {
                this.handleTextChange(val);
            }
        },
        'altanoti.switch'(val) {
            if (val != null) {
                if (val == false) {
                    this.btnusuario = true;
                    this.btnperfil = true;
                    this.valNotiDatosExtra = (this.altanoti.perfil.length > 0 || this.altanoti.usuario.length > 0) ? true : false;
                    this.valNoti = false;
                } else {
                    this.btnusuario = false;
                    this.btnperfil = false;
                    this.valNotiDatosExtra = false;
                }
            }
        },
        'altacorreo.switch'(val) {
            if (val != null) {
                if (val == false) {
                    this.discorreos = true;
                    this.btnpcorreo = true;
                    this.valCorreoDatosExtra = ((this.altacorreo.pcorreo.length > 0 || this.altacorreo.pcorreocopia.length > 0 ||
                        this.altacorreo.pcorreocopiaoculta.length > 0 || this.correos.selectedItems.length > 0 || this.correosCO.selectedItems.length > 0 ||
                        this.correosCO.selectedItems.length > 0) && (this.altacorreo.textcorreo != '' || this.altacorreo.textcorreo != null)) ? true : false;
                    this.valcorreo = false;

                    this.closeChipCorreo = false;
                } else {
                    this.discorreos = false;
                    this.btnpcorreo = false;
                    this.valCorreoDatosExtra = false;
                    this.closeChipCorreo = true;
                }
                if (this.showEditar) {
                    this.closeChipCorreo = false;
                }
            }
        },
        'altasms.switch'(val) {
            if (val != null) {
                if (val == false) {
                    this.btnptel = true;
                    this.distels = true;
                    this.valSMS = false;

                    this.valsmsDatosExtra = ((this.altasms.perfilTel.length > 0 || this.telefonos.selectedItems.length > 0)
                        && (this.altasms.textsms.trim().length != 0 || this.altaWhatsapp.textWhatsapp.trim().length != 0 || this.altaWhatsapp.txtWhatsappUS.trim().length != 0)
                        && ((this.altasms.switch == false || this.altasms.switch == null) && (this.altaWhatsapp.switch == false || this.altaWhatsapp.switch == null))) ? true : false;
                    this.closeChipSMS = false;
                } else {
                    this.btnptel = false;
                    this.distels = false;
                    this.valsmsDatosExtra = false;
                    this.valWhatsDatosExtra = false;
                    this.closeChipSMS = true;
                }
                if (this.showEditar) {
                    this.closeChipSMS = false;
                }
            }
        },
        'altaWhatsapp.switch'(val) {
            if (val != null) {
                if (val == false) {
                    this.btnptelW = true;
                    this.distelsW = true;
                    this.valWhats = false;
                    this.valWhatsDatosExtra = ((this.altasms.perfilTel.length > 0 || this.telefonos.selectedItems.length > 0)
                        && (this.altasms.textsms.trim().length != 0 || this.altaWhatsapp.textWhatsapp.trim().length != 0 || this.altaWhatsapp.txtWhatsappUS.trim().length != 0)
                        && ((this.altasms.switch == false || this.altasms.switch == null) && (this.altaWhatsapp.switch == false || this.altaWhatsapp.switch == null))) ? true : false;

                    this.closeChip = false;
                } else {
                    this.btnptelW = false;
                    this.distelsW = false;
                    this.valWhatsDatosExtra = false;
                    this.valsmsDatosExtra = false;
                    this.closeChip = true;
                }
                if (this.showEditar) {
                    this.closeChip = false;
                }
            }
        },
        'alta.sitio'(val) {
            if (val != null) {
                this.valSitio = false;
            }
        },
        'altanoti.usuario'(val) {
            if (val != null) {
                this.valNoti = false;
            }
        },
        'altanoti.perfil'(val) {
            if (val != null) {
                this.valNoti = false;
            }
        },
        'altacorreo.pcorreo'(val) {
            if (val != null) {
                this.valcorreo = false;
            }
        },
        'altasms.perfilTel'(val) {
            if (val != null) {
                this.valSMS = false;
                this.valWhats = false;
            }
        },
        'altaWhatsapp.perfilTel'(val) {
            if (val != null) {
                this.valSMS = false;
                this.valWhats = false;
            }
        },
        'altaWhatsapp.nameTemplate'(val) {
            this.valtxtW = false;
            if (val != '') {
                this.valtemp = false;

            }
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 60)//Permiso para Sistemas
                        this.permisoSistemas = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        this.uslogin = await MetodosGenerales.ObtenerUserName();
        let datos = await MetodosGenerales.obtenerSessionReporte("proceso");
        await Sistemas.ObtenerCatalogo(this, 'sitio');
        await Sistemas.ObtenerPerfiles(this, 'usuario');
        await Sistemas.ObtenerPerfiles(this, 'correo');
        await Sistemas.ObtenerPerfiles(this, 'telefono');
        await Sistemas.ObtenerUsuarios(this);
        await Sistemas.DetalleProceso(this, datos.ntclave);
        await Sistemas.DetalleAsignacionNotificacion(this, datos.ntclave);
        this.loaded = false;
        this.btnusuario = true;
        this.btnswitch = true;
        this.btnperfil = true;

        this.btnswitch2 = true;
        this.btnpcorreo = true;
        this.discorreos = true;

        this.btnswitch3 = true;
        this.distels = true;
        this.btnptel = true;

        this.btnswitch4 = true;
        this.distelsW = true;
        this.btnptelW = true;
    },
    methods: {
        Cancelar() {
            this.$router.push({ name: 'AdmNotiBusqueda' }).catch((error) => error);
        },
        handleTextChange(val) {
            this.valtxtW = false;
            this.valtemp = false;
            if (val != '') {
                if (val.trim().length >= 12) {
                    this.btnswitch4 = false;
                    this.altaWhatsapp.switch = true;
                    this.btnptelW = false;
                    this.distelsW = false;
                    this.valSinText = false;
                } else {
                    this.btnswitch4 = true;
                    this.altaWhatsapp.switch = false;
                    this.btnptelW = true;
                    this.distelsW = true;
                }
            } else {
                this.altaWhatsapp.switch = this.altaWhatsapp.textWhatsapp.trim().length > 0 || this.altaWhatsapp.txtWhatsappUS.trim().length > 0 ? true : false;
                this.distelsW = this.altaWhatsapp.textWhatsapp.trim().length > 0 || this.altaWhatsapp.txtWhatsappUS.trim().length > 0 ? false : true;
                this.btnswitch4 = this.altaWhatsapp.textWhatsapp.trim().length > 0 || this.altaWhatsapp.txtWhatsappUS.trim().length > 0 ? false : true;
            }
        },
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        async limpiar() {
            this.$refs.form.reset();
            let datos = await MetodosGenerales.obtenerSessionReporte("proceso");
            this.alta = {
                proceso: null,
                sitio: null,
                modulo: null,
                ntclave: datos.ntclave
            };
            this.altanoti = {
                perfil: [],
                textNoti: '',
                switch: false,
                usuario: []
            };
            this.btnswitch = true;
            this.btnusuario = true;
            this.btnperfil = true;
            this.valSitio = false;
            this.valSinText = false;
            this.altacorreo = {
                textcorreo: '',
                switch: false,
                pcorreo: [],
                pcorreocopia: [],
                pcorreocopiaoculta: []
            };
            this.correos = {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            };
            this.correosCopia = {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            };
            this.correosCO = {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            };
            this.hasErrorsC = false;
            this.hasErrors = false;
            this.hasErrorsS = false;
            this.telefonos = {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            };
            this.altasms = {
                textsms: '',
                switch: false,
                perfilTel: [],
            };
            this.btnswitch = true;
            this.btnswitch2 = true;
            this.btnswitch3 = true;
            this.btnswitch4 = true;
            this.valWhats = false;
            this.altaWhatsapp = {
                textWhatsapp: '',
                switch: false,
                perfilTel: [],
                txtWhatsappUS: '',
                nameTemplate: ''
            };
            this.hasErrorsW = false;
            this.telefonosW = {
                items: [],
                valor: null,
                searchIteam: "",
                selectedItems: []
            };
            this.valtemp = false;
            this.altapush = {
                textNotiPush: ''
            };
            this.hasErrorsP = false;
            this.valtxtW = false;

            this.valNotiDatosExtra = false;
            this.valCorreoDatosExtra = false;
            this.valsmsDatosExtra = false;
            this.valWhatsDatosExtra = false;
        },
        addTelValider(tipo) {
            var regex = /^\d{10}$/;
            if (tipo == 'tel') {
                if (regex.test(this.telefonos.searchIteam)) {
                    let indice = this.telefonos.selectedItems.findIndex(obj => obj === this.telefonos.searchIteam);
                    if (indice == -1) {
                        this.telefonos.items = [
                            {
                                value: this.telefonos.searchIteam,
                                text: this.telefonos.searchIteam,
                            },
                        ];
                    }
                    this.valSMS = false;
                    this.valWhats = false;
                }
            }
        },
        addMailValider(tipo) {
            var regex = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;
            if (tipo == 'correo') {
                if (regex.test(this.correos.searchIteam)) {
                    let indice = this.correos.selectedItems.findIndex(obj => obj === this.correos.searchIteam);
                    if (indice == -1) {
                        this.correos.items = [
                            {
                                value: this.correos.searchIteam,
                                text: this.correos.searchIteam,
                            },
                        ];
                        this.valcorreo = false;
                    }
                }
            } else if (tipo == 'copia') {
                if (regex.test(this.correosCopia.searchIteam)) {
                    let indice = this.correosCopia.selectedItems.findIndex(obj => obj === this.correosCopia.searchIteam);
                    if (indice == -1) {
                        this.correosCopia.items = [
                            {
                                value: this.correosCopia.searchIteam,
                                text: this.correosCopia.searchIteam,
                            },
                        ];
                    }
                }
            } else if (tipo == 'co') {
                if (regex.test(this.correosCO.searchIteam)) {
                    let indice = this.correosCO.selectedItems.findIndex(obj => obj === this.correosCO.searchIteam);
                    if (indice == -1) {
                        this.correosCO.items = [
                            {
                                value: this.correosCO.searchIteam,
                                text: this.correosCO.searchIteam,
                            },
                        ];
                    }
                }
            }
        },
        deleteFromList(tipo, item) {
            if (tipo == 'correo') {
                this.correos.selectedItems = this.correos.selectedItems.filter((element) => element !== item);
                if (this.correos.selectedItems.length == 0) {
                    this.correos.valor = null;
                }
            } else if (tipo == 'copia') {
                this.correosCopia.selectedItems = this.correosCopia.selectedItems.filter((element) => element !== item);
                if (this.correosCopia.selectedItems.length == 0) {
                    this.correosCopia.valor = null;
                }
            } else if (tipo == 'co') {
                this.correosCO.selectedItems = this.correosCO.selectedItems.filter((element) => element !== item);
                if (this.correosCO.selectedItems.length == 0) {
                    this.correosCO.valor = null;
                }
            } else if (tipo == 'tel') {
                this.telefonos.selectedItems = this.telefonos.selectedItems.filter((element) => element !== item);
                if (this.telefonos.selectedItems.length == 0) {
                    this.telefonos.valor = null;
                }
            } else if (tipo == 'whatsapp') {
                this.telefonosW.selectedItems = this.telefonosW.selectedItems.filter((element) => element !== item);
                if (this.telefonosW.selectedItems.length == 0) {
                    this.telefonosW.valor = null;
                }
            }
        },
        resetItemsSelector(tipo) {
            if (tipo == 'correo') {
                if (this.correos.valor != null) {
                    this.mailSelected++;
                    this.correos.selectedItems.push(this.correos.valor);
                    this.correos.searchIteam = null;
                    this.correos.items = null;
                }
            } else if (tipo == 'copia') {
                if (this.correosCopia.valor != null) {
                    this.mailSelected++;
                    this.correosCopia.selectedItems.push(this.correosCopia.valor);
                    this.correosCopia.searchIteam = null;
                    this.correosCopia.items = null;
                }
            } else if (tipo == 'co') {
                if (this.correosCO.valor != null) {
                    this.mailSelected++;
                    this.correosCO.selectedItems.push(this.correosCO.valor);
                    this.correosCO.searchIteam = null;
                    this.correosCO.items = null;
                }
            } else if (tipo == 'tel') {
                if (this.telefonos.valor != null) {
                    this.telefonos.selectedItems.push(this.telefonos.valor);
                    this.telefonos.searchIteam = null;
                    this.telefonos.items = null;
                }
            } else if (tipo == 'whatsapp') {
                if (this.telefonosW.valor != null) {
                    this.telefonosW.selectedItems.push(this.telefonosW.valor);
                    this.telefonosW.searchIteam = null;
                    this.telefonosW.items = null;
                }
            }
        },
        Editar() {
            this.showEditar = false;
            this.disEditar = false;

            /*Notificacion */
            const textoNoti = this.altanoti && this.altanoti.textNoti ? this.altanoti.textNoti.trim() : "";
            this.btnswitch = textoNoti.trim().length >= 12 ? false : true;
            this.altanoti.switch = (this.altanoti.usuario.length > 0 || this.altanoti.perfil.length > 0) ? true : false;
            this.btnusuario = (textoNoti.trim().length >= 12 && (this.altanoti.usuario.length > 0 || this.altanoti.perfil.length > 0)) ? false : true;
            this.btnperfil = (textoNoti.trim().length >= 12 && (this.altanoti.usuario.length > 0 || this.altanoti.perfil.length > 0)) ? false : true;

            /*Correo*/
            const textoCorreo = this.altacorreo && this.altacorreo.textcorreo ? this.altacorreo.textcorreo.trim() : "";
            this.btnswitch2 = textoCorreo.length >= 12 ? false : true;
            this.altacorreo.switch = (textoCorreo.length >= 12 && (this.altacorreo.pcorreo.length > 0 || this.altacorreo.pcorreocopia.length > 0 || this.altacorreo.pcorreocopiaoculta.length > 0
                || this.correos.selectedItems.length > 0 || this.correosCopia.selectedItems.length > 0 || this.correosCO.selectedItems.length > 0)) ? true : false;
            this.btnpcorreo = (textoCorreo.length >= 12 && (this.altacorreo.pcorreo.length > 0 || this.altacorreo.pcorreocopia.length > 0 || this.altacorreo.pcorreocopiaoculta.length > 0
                || this.correos.selectedItems.length > 0 || this.correosCopia.selectedItems.length > 0 || this.correosCO.selectedItems.length > 0)) ? false : true;
            this.discorreos = (textoCorreo.length >= 12 && (this.altacorreo.pcorreo.length > 0 || this.altacorreo.pcorreocopia.length > 0 || this.altacorreo.pcorreocopiaoculta.length > 0
                || this.correos.selectedItems.length > 0 || this.correosCopia.selectedItems.length > 0 || this.correosCO.selectedItems.length > 0)) ? false : true;
            this.closeChipCorreo = true;
            this.closeChip = true;
            this.closeChipSMS = true;

            /*SMS*/
            const textoSMS = this.altasms && this.altasms.textsms ? this.altasms.textsms.trim() : "";
            this.btnswitch3 = textoSMS.trim().length >= 12 ? false : true;
            this.distels = textoSMS.trim().length >= 12 ? false : true;
            this.btnptel = textoSMS.trim().length >= 12 ? false : true;

            /*Whatsapp */
            const textoWh = this.altaWhatsapp && this.altaWhatsapp.textWhatsapp ? this.altaWhatsapp.textWhatsapp.trim() : "";
            const textoWhENG = this.altaWhatsapp && this.altaWhatsapp.txtWhatsappUS ? this.altaWhatsapp.txtWhatsappUS.trim() : "";

            this.btnswitch4 = (textoWh.trim().length || textoWhENG.trim().length) >= 12 ? false : true;
            this.distelsW = (textoWh.trim().length || textoWhENG.trim().length) >= 12 ? false : true;
            this.btnptelW = (textoWh.trim().length || textoWhENG.trim().length) >= 12 ? false : true;

            /*push*/
            const textopush = this.altapush && this.altapush.textNotiPush ? this.altapush.textNotiPush.trim() : "";
            //this.altapush.textNotiPush 
        },
        async Guardar() {
            await this.Validar();
            if (this.val == 0 && this.valn == 0 && this.valc == 0 && this.vals == 0 && this.valw == 0 && this.valp == 0 &&
                this.valNotiDatosExtra == false && this.valCorreoDatosExtra == false && this.valsmsDatosExtra == false && this.valWhatsDatosExtra == false) {
                this.btndis = true;
                this.$swal({
                    title: 'Guardando proceso, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let proceso = {
                            ntclave: this.alta.ntclave,
                            ntproceso: this.alta.proceso,
                            nttxtnotificacion: this.altanoti.textNoti == null ? '' : this.altanoti.textNoti.trim(),
                            nttxtcorreo: this.altacorreo.textcorreo == null ? '' : this.altacorreo.textcorreo.trim(),
                            nttxtsms: this.altasms.textsms == null ? '' : this.altasms.textsms.trim(),
                            nttxtwhatsapp: this.altaWhatsapp.textWhatsapp == null ? '' : this.altaWhatsapp.textWhatsapp.trim(),
                            nttxtwhatsappUS: this.altaWhatsapp.txtWhatsappUS == null ? '' : this.altaWhatsapp.txtWhatsappUS.trim(),
                            nttemplatews: this.altaWhatsapp.nameTemplate == '' ? '' : this.altaWhatsapp.nameTemplate,
                            ntsitio: this.alta.sitio.ntsitio,
                            ntmodulo: this.alta.modulo,
                            dnuslogin: this.altanoti.usuario.length > 0 ? this.altanoti.usuario.map(obj => obj.Login).join(',') : '',
                            pfclaveUsuarios: this.altanoti.perfil.length > 0 ? this.altanoti.perfil.map(obj => obj.pfclave).join(',') : '',
                            dnemail: this.correos.selectedItems.join(','),
                            pfclaveCorreos: this.altacorreo.pcorreo.map(obj => obj.pfclave).join(','),
                            dnemailcc: this.correosCopia.selectedItems.join(','),
                            pfclaveCorreoscc: this.altacorreo.pcorreocopia.map(obj => obj.pfclave).join(','),
                            dnemailcco: this.correosCO.selectedItems.join(','),
                            pfclaveCorreoscco: this.altacorreo.pcorreocopiaoculta.map(obj => obj.pfclave).join(','),
                            pfclaveTelefono: this.altasms.perfilTel.map(obj => obj.pfclave).join(','),
                            dnTelefono: this.telefonos.selectedItems.join(','),
                            ticlave: null,
                            nttxtpushnotificacion: this.altapush.textNotiPush == null ? '' : this.altapush.textNotiPush.trim()
                        }
                        this.btndis = false;

                        let response = await Sistemas.ActualizarProceso(proceso, this.uslogin)
                        if (response) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Proceso actualizado correctamente.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                window.location.reload();
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrió un error al actualizar el proceso, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.btndis = false;
                            });
                        }
                    }
                })
            }
        },
        async Validar() {
            this.val = 0; this.valn = 0; this.valc = 0; this.vals = 0; this.valw = 0; this.valp = 0;
            let textNoti = this.altanoti.textNoti == null ? '' : this.altanoti.textNoti;
            let textCorreo = this.altacorreo.textcorreo == null ? '' : this.altacorreo.textcorreo;
            let textSms = this.altasms.textsms == null ? '' : this.altasms.textsms;
            let textWhats = this.altaWhatsapp.textWhatsapp == null ? '' : this.altaWhatsapp.textWhatsapp;
            let textWhatsUS = this.altaWhatsapp.txtWhatsappUS == null ? '' : this.altaWhatsapp.txtWhatsappUS;

            let textNotiPush = this.altapush.textNotiPush == null ? '' : this.altapush.textNotiPush;

            this.$refs.form.validate()
            if (this.alta.sitio == null) {
                this.valSitio = true;
                this.val++;
            }
            if (textNoti == '' && textCorreo == '' && textSms == '' && textWhats == '' && textWhatsUS == '' && textNotiPush == '') {
                this.valSinText = true;
                this.val++;
            }
            if (this.altanoti.switch == true && (this.altanoti.perfil.length == 0 && this.altanoti.usuario.length == 0)) {
                this.valNoti = true;
                this.valn++;
            }

            if (textNoti.trim().length > 0) {
                if (textNoti.trim().length < 12) {
                    this.valn++;
                }
            }

            if (this.altacorreo.switch && (this.altacorreo.pcorreo.length == 0 && this.correos.selectedItems.length == 0)) {
                this.valcorreo = true;
                this.valc++
            }
            if (textCorreo.trim().length > 0) {
                if (textCorreo.trim().length < 12) {
                    this.valc++;
                }
            }
            if (textSms.trim().length > 0) {
                if (textSms.trim().length < 12) {
                    this.vals++;
                }
            }
            if (this.altasms.switch && (this.altasms.perfilTel.length == 0 && this.telefonos.selectedItems.length == 0)) {
                this.valSMS = true;
                this.vals++;
            }
            if (this.altaWhatsapp.switch && (this.altasms.perfilTel.length == 0 && this.telefonos.selectedItems.length == 0)) {
                this.valWhats = true;
                this.valw++;
            }
            if (textWhats.trim().length > 0) {
                if (textWhats.trim().length < 12) {
                    this.valw++;
                }
            }
            if ((textWhats.trim().length > 0 || textWhatsUS.trim().length > 0) && this.altaWhatsapp.nameTemplate == '') {
                this.valtemp = true;
                this.valw++;
            }

            if (textNotiPush.trim().length > 0) {
                if (textNotiPush.trim().length < 12) {
                    this.valp++;
                }
            }
            if ((this.altaWhatsapp.nameTemplate != '') && (textWhats == '' && textWhatsUS == '')) {
                this.valw++;
                this.valtxtW = true;

            }
            if (this.valNotiDatosExtra || this.valCorreoDatosExtra || this.valsmsDatosExtra || this.valWhatsDatosExtra) {


                let textn = "Campo usuario o perfil usuario no son requeridos. ";
                let textemail = "Campo correo o perfil correo no son requeridos. ";
                let texttel = "Campo teléfono o perfil teléfono no son requeridos. ";
                let texto = "";

                if (this.valNotiDatosExtra) { texto = texto + textn + "<br>" }
                if (this.valCorreoDatosExtra) { texto = texto + textemail + "<br>" }
                if (this.valsmsDatosExtra || this.valWhatsDatosExtra) { texto = texto + texttel + "<br>" }

                this.$swal({
                    position: "center",
                    icon: "info",
                    title: 'Tienes valores que no se requieren',
                    html: texto + "<br>¿Desea eliminar los valores no requeridos?",
                    showCancelButton: true,
                    confirmButtonColor: '#536DFE',
                    cancelButtonColor: '#FF5C93',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (this.valNotiDatosExtra) {
                            this.altanoti.perfil = [];
                            this.altanoti.usuario = [];
                            this.valNotiDatosExtra = false;
                        }
                        if (this.valCorreoDatosExtra) {
                            this.altacorreo.pcorreo = [];
                            this.altacorreo.pcorreocopia = [];
                            this.altacorreo.pcorreocopiaoculta = [];

                            this.correos = {
                                items: [],
                                valor: null,
                                searchIteam: "",
                                selectedItems: []
                            };
                            this.correosCopia = {
                                items: [],
                                valor: null,
                                searchIteam: "",
                                selectedItems: []
                            };
                            this.correosCO = {
                                items: [],
                                valor: null,
                                searchIteam: "",
                                selectedItems: []
                            };
                            this.valCorreoDatosExtra = false;
                        }
                        if (this.valWhatsDatosExtra || this.valsmsDatosExtra) {
                            this.altasms.perfilTel = [];
                            this.telefonos = {
                                items: [],
                                valor: null,
                                searchIteam: "",
                                selectedItems: []
                            };
                            this.valWhatsDatosExtra = false;
                            this.valsmsDatosExtra = false;
                        }
                    }
                })
            }

            this.hasErrors = this.valn > 0 ? true : false;
            this.hasErrorsC = this.valc > 0 ? true : false;
            this.hasErrorsS = this.vals > 0 ? true : false;
            this.hasErrorsW = this.valw > 0 ? true : false;
            this.hasErrorsP = this.valp > 0 ? true : false;
        }
    },
}
</script>